import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useIsMeridianUser } from '@/contexts/FeatureFlagContext';

export default function EvalPage() {
  const navigate = useNavigate();
  const isAdmin = useIsMeridianUser();

  useEffect(() => {
    if (isAdmin) {
      navigate('/eval/results?groupBy=run', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [navigate, isAdmin]);

  return null;
}
